// src/components/TopBanner.js
import React, { useState, useEffect, useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { getTopBannerMessages } from "../services/topBanner.api";

function TopBanner() {
  const { lang } = useContext(LanguageContext);

  const [messages, setMessages] = useState([]);

useEffect(() => {
  getTopBannerMessages()
    .then((rows) =>
      setMessages(
        rows.map((r) => (lang === "EN" ? r.message_en : r.message_ar))
      )
    )
    .catch(() => {});
}, [lang]);


  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % messages.length);
        setFade(true);
      }, 300);
    }, 4000);

    return () => clearInterval(timer);
  }, [messages.length]);

  // Background gradient animation keyframes
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes gradientShift {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // Small Italian flag SVG
  const ItalianFlag = (
    <svg
      width="14"
      height="10"
      viewBox="0 0 3 2"
      className="inline-block mx-1"
      style={{ borderRadius: "2px", boxShadow: "0 0 3px rgba(0,0,0,0.3)" }}
    >
      <rect width="1" height="2" x="0" fill="#009246" />
      <rect width="1" height="2" x="1" fill="#F1F2F1" />
      <rect width="1" height="2" x="2" fill="#CE2B37" />
    </svg>
  );

  return (
    <div
      className="w-full text-center py-2 relative overflow-hidden"
      style={{
        background: "linear-gradient(90deg, #1a1a1a, #2d2d2d, #1a1a1a)",
        backgroundSize: "200% 200%",
        animation: "gradientShift 8s ease-in-out infinite",
        color: "#ffffff",
      }}
    >
      <span
        className={`
          inline-flex items-center justify-center gap-1 font-semibold
          transition-all duration-500
          ${fade ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-1"}
        `}
        style={{
          fontSize: lang === "AR" ? "13px" : "10px",
          direction: lang === "AR" ? "rtl" : "ltr",
          textShadow: "0px 0px 6px rgba(255, 255, 255, 0.35)",
        }}
      >
        {/* Flag placement adjusts automatically for EN/AR */}
        {lang === "EN" && ItalianFlag}
        {messages[index]}
        {lang === "AR" && ItalianFlag}
      </span>
    </div>
  );
}

export default TopBanner;
